import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
const Layout = () => {
  const navbarRef = useRef(null);
  const [showAppBar, setShowAppBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down, hide AppBar
        setShowAppBar(false);
      } else {
        // Scrolling up, show AppBar
        setShowAppBar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      <Header />

      <div>
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
